import { useCallback, useEffect, useState } from 'react';
import { useRecoilValue, useSetRecoilState } from 'recoil';

import type { TFacilities } from '../types';
import { activeRequestsAtom } from '../../atoms';
import { fullDataAtom } from '../../atoms/fullDataAtom';

export function useGetFacilities() {
  const [facilities, setFacilities] = useState<TFacilities[] | null>(null);
  const setActiveRequests = useSetRecoilState(activeRequestsAtom);
  const fullExpertData = useRecoilValue(fullDataAtom);

  const getFacilities = useCallback(async () => {
    if (!fullExpertData) {
      return;
    }
    setActiveRequests(prev => prev + 1);

    // Защита: у экспертов без настроенных услуг expertFacilities
    // (или expertServices внутри него) может отсутствовать вообще.
    const services = fullExpertData.expertFacilities?.expertServices ?? [];

    // remote services was hidden
    setFacilities(services.filter(service => !!service.geolocation?.fullAddress));
    // }
    setActiveRequests(prev => prev - 1);
  }, [fullExpertData, setActiveRequests]);

  useEffect(() => {
    getFacilities();
    // Перезапускаем при каждом обновлении fullExpertData — та же причина,
    // что и в useGetExpertData: компонент страницы эксперта не размонтируется
    // между разными :id, значит эффект с [] замораживал бы данные
    // первого открытого эксперта.
  }, [fullExpertData, getFacilities]);

  return { facilities };
}